import {BaseInterface as WarningsBaseInterface} from './Success/Warnings/BaseInterface';

export class Success {

    private body: any = null;

    private warnings: WarningsBaseInterface[] = null;

    // ########################################

    constructor(
        body: any,
        warnings: WarningsBaseInterface[]
    ) {
        this.body = body;
        this.warnings = warnings;
    }

    // ########################################

    public getBody(): any {
        return this.body;
    }

    public getWarnings(): WarningsBaseInterface[] {
        return this.warnings;
    }

    // ########################################
}
